import { createContext, useContext } from 'react';

export const TabListContext = createContext();
export const useTabListContext = () => useContext(TabListContext);
